/**
 * Below this many seconds a buyer pays for calls that drop right after connecting, so the
 * campaign forms warn about it. Used for the Static minimum duration and the Programmatic fixed
 * call length.
 */
export const MINIMUM_DURATION_WARNING_THRESHOLD_SECONDS = 10

/**
 * Whether a minimum call duration is short enough to warn about. An empty or unset value counts
 * as 0.
 *
 * @param {number|string|null|undefined} seconds
 * @returns {boolean}
 */
export function isMinimumDurationTooShort(seconds) {
  return (Number(seconds) || 0) < MINIMUM_DURATION_WARNING_THRESHOLD_SECONDS
}
